"use strict";

var __extends = this && this.__extends || function () {
  var _extendStatics = function extendStatics(d, b) {
    _extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) {
        if (b.hasOwnProperty(p)) d[p] = b[p];
      }
    };

    return _extendStatics(d, b);
  };

  return function (d, b) {
    _extendStatics(d, b);

    function __() {
      this.constructor = d;
    }

    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();

var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
  }
  result["default"] = mod;
  return result;
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var react_1 = __importStar(require("react"));

var react_dom_1 = require("react-dom");

var styles_1 = __importDefault(require("./styles"));

var classnames_1 = __importDefault(require("classnames"));

var context = react_1.createContext('modal-container');
exports.Provider = context.Provider;
exports.Consumer = context.Consumer;

exports.ModalContent = function (_a) {
  var title = _a.title,
      children = _a.children,
      footer = _a.footer,
      onClose = _a.onClose,
      className = _a.className,
      headerClassName = _a.headerClassName,
      bodyClassName = _a.bodyClassName,
      footerClassName = _a.footerClassName;
  return react_1.default.createElement("div", {
    className: classnames_1.default('modal-content', className)
  }, react_1.default.createElement("div", {
    className: classnames_1.default('modal-header', headerClassName)
  }, react_1.default.createElement("h5", {
    className: 'modal-title'
  }, title), onClose && react_1.default.createElement("button", {
    onClick: onClose,
    type: 'button',
    className: 'close',
    "data-dismiss": 'modal',
    "aria-label": 'Close'
  }, react_1.default.createElement("span", {
    "aria-hidden": 'true'
  }, "\xD7"))), children && react_1.default.createElement("div", {
    className: classnames_1.default('modal-body', bodyClassName)
  }, children), footer && react_1.default.createElement("div", {
    className: classnames_1.default('modal-footer', footerClassName)
  }, footer));
};

var ModalPortal =
/** @class */
function (_super) {
  __extends(ModalPortal, _super);

  function ModalPortal() {
    var _this = _super !== null && _super.apply(this, arguments) || this;

    _this.stopPropagation = function (ev) {
      ev.stopPropagation();
    };

    _this.renderModal = function () {
      var _a;

      var _b = _this.props,
          open = _b.open,
          children = _b.children,
          onClose = _b.onClose,
          classes = _b.classes,
          className = _b.className,
          dialogClassName = _b.dialogClassName;
      return react_1.default.createElement(react_1.Fragment, null, react_1.default.createElement("div", {
        onClick: onClose,
        className: classnames_1.default('modal fade', {
          show: open
        }, className),
        style: {
          display: open ? 'block' : ''
        },
        role: 'dialog',
        "aria-hidden": 'true'
      }, react_1.default.createElement("div", {
        className: classnames_1.default('modal-dialog', dialogClassName),
        role: 'document',
        onClick: _this.stopPropagation
      }, react_1.default.cloneElement(children, {
        onClose: onClose
      }))), react_1.default.createElement("div", {
        className: classnames_1.default('modal-backdrop', classes.modalBackdrop, (_a = {
          show: open
        }, _a[classes.show] = open, _a)),
        onClick: onClose
      }));
    };

    _this.renderPortal = function (id) {
      var node = document.getElementById(id);

      if (!node) {
        throw new Error("No element found with id: " + id);
      } else {
        return react_dom_1.createPortal(_this.renderModal(), node);
      }
    };

    return _this;
  }

  ModalPortal.prototype.componentDidUpdate = function (props) {
    if (this.props.open) {
      document.body.style['height'] = '100vh';
      document.body.style['overflow'] = 'hidden';
    } else {
      document.body.style['height'] = 'initial';
      document.body.style['overflow'] = 'initial';
    }
  };

  ModalPortal.prototype.render = function () {
    return react_1.default.createElement(exports.Consumer, null, this.renderPortal);
  };

  return ModalPortal;
}(react_1.Component);

exports.default = styles_1.default(ModalPortal);